import { useQuery } from 'react-query';
import { handleRequest } from '../../../redux/services/APIService';
import storageHelper from '../../../libs/storageHelper';

export const useGetTriageCounts = (enabled = true) => {
  return useQuery(
    ['getTriageCounts'],
    async () => {
      const { user } = storageHelper.getFromStorage('loggedUser');
      const response = await handleRequest(
        'get',
        `facility/${user.facility}/triage-counts`,
        true,
      );
      return (
        response.data || {
          refillRequests: 0,
          appointmentRequests: 0,
          inquiries: 0,
        }
      );
    },
    {
      enabled,
      refetchInterval: 60000,
      refetchOnWindowFocus: true,
      onError: (error) => {
        console.error(
          `${error.response?.data?.data?.resultMessage || error.message}`,
        );
      },
    },
  );
};
